// ReceptionColis.jsx
import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { db, storage } from "../firebase";
import { addDoc, collection } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import jsPDF from "jspdf";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ReceptionColis() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    colisNom: "",
    dateAchat: "",
    montantAchat: "",
    nombreArticles: "", // <-- Ajout ici
    envoyeurNom: "",
    envoyeurTel: "",
    envoyeurAdresse: "",
    recepteurNom: "",
    recepteurTel: "",
    recepteurAdresse: "",
    montantShipping: "",
    montantDepot: "",
    montantReste: "",
    images: [],
  });

  const [imagePreviews, setImagePreviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const { montantShipping, montantDepot } = formData;
    const reste = parseFloat(montantShipping || 0) - parseFloat(montantDepot || 0);
    setFormData((prev) => ({
      ...prev,
      montantReste: isNaN(reste) || reste < 0 ? "" : reste.toFixed(2),
    }));
  }, [formData.montantShipping, formData.montantDepot]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({ ...formData, images: files });
    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  };

  const generateTicketPDF = ({ recepteurNom, envoyeurNom, recepteurTel }) => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.setFont("courier", "bold");
    doc.text("GO SHIPPING", 10, 10);
    doc.setFontSize(12);
    doc.text("Nom à mettre sur le colis:", 10, 20);
    doc.setFontSize(16);
    doc.text(recepteurNom.toUpperCase(), 10, 30);
    doc.setFontSize(14);
    doc.text(`S/C ${envoyeurNom.toUpperCase()}`, 10, 40);
    doc.setFontSize(12);
    doc.text(`Téléphone: ${recepteurTel}`, 10, 50);
    doc.setFontSize(10);
    doc.text("Merci pour votre confiance!", 10, 70);
    doc.save(`ticket_${recepteurNom}.pdf`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const {
        colisNom,
        dateAchat,
        montantAchat,
        nombreArticles, // <-- Ajout ici
        envoyeurNom,
        envoyeurTel,
        envoyeurAdresse,
        recepteurNom,
        recepteurTel,
        recepteurAdresse,
        montantShipping,
        montantDepot,
        montantReste,
        images,
      } = formData;

      if (!colisNom || !dateAchat || !envoyeurNom || !envoyeurTel || !recepteurNom || !recepteurTel) {
        window.toast && toast.error("Champs obligatoires manquants.");
        setLoading(false);
        return;
      }

      const imageUrls = [];
      for (const image of images) {
        const imageRef = ref(storage, `colis/${uuidv4()}_${image.name}`);
        await uploadBytes(imageRef, image);
        const downloadURL = await getDownloadURL(imageRef);
        imageUrls.push(downloadURL);
      }

      await addDoc(collection(db, "colis"), {
        colisNom,
        dateAchat,
        montantAchat,
        nombreArticles, // <-- Ajout ici
        envoyeurNom,
        envoyeurTel,
        envoyeurAdresse,
        recepteurNom,
        recepteurTel,
        recepteurAdresse,
        montantShipping,
        montantDepot,
        montantReste,
        imageUrls,
        statut: "commande",
        createdAt: new Date(),
      });

      generateTicketPDF({ recepteurNom, envoyeurNom, recepteurTel });
      window.toast && toast.success("Colis enregistré avec succès.");
      navigate("/admin/ListeColis");
    } catch (error) {
      console.error("Erreur:", error);
      window.toast && toast.error("Erreur lors de l'enregistrement du colis.");
    }
    setLoading(false);
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="container py-4" style={{ marginLeft: "250px" }}>
        <h2>📦 Ajouter un colis</h2>
        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-md-4">
            <label>Nom du colis</label>
            <input type="text" name="colisNom" value={formData.colisNom} onChange={handleChange} className="form-control" required />
          </div>
          <div className="col-md-3">
            <label>Nombre d'articles dans le colis</label>
            <input
              type="number"
              name="nombreArticles"
              value={formData.nombreArticles}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          {/* <div className="col-md-4">
            <label>Date de réception</label>
            <input type="date" name="dateReception" value={formData.dateReception} onChange={handleChange} className="form-control" required />
          </div> */}
          <div className="col-md-4">
            <label>Date d'achat du colis</label>
            <input
              type="date"
              name="dateAchat"
              value={formData.dateAchat}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-4">
            <label>Montant d'achat du colis</label>
            <input
              type="number"
              name="montantAchat"
              value={formData.montantAchat}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-4">
            <label>Montant du shipping</label>
            <input type="number" name="montantShipping" value={formData.montantShipping} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Dépôt effectué</label>
            <input type="number" name="montantDepot" value={formData.montantDepot} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-4">
            <label>Reste à payer</label>
            <input type="number" name="montantReste" value={formData.montantReste} readOnly className="form-control" />
          </div>

          <div className="col-md-6">
            <label>Nom de l'envoyeur</label>
            <input type="text" name="envoyeurNom" value={formData.envoyeurNom} onChange={handleChange} className="form-control" required />
          </div>
          <div className="col-md-6">
            <label>Tél de l'envoyeur</label>
            <input type="tel" name="envoyeurTel" value={formData.envoyeurTel} onChange={handleChange} className="form-control" required />
          </div>
          <div className="col-md-12">
            <label>Adresse de l'envoyeur (facultatif)</label>
            <input type="text" name="envoyeurAdresse" value={formData.envoyeurAdresse} onChange={handleChange} className="form-control" />
          </div>

          <div className="col-md-6">
            <label>Nom du récepteur</label>
            <input type="text" name="recepteurNom" value={formData.recepteurNom} onChange={handleChange} className="form-control" required />
          </div>
          <div className="col-md-6">
            <label>Tél du récepteur</label>
            <input type="tel" name="recepteurTel" value={formData.recepteurTel} onChange={handleChange} className="form-control" required />
          </div>
          <div className="col-md-12">
            <label>Adresse du récepteur (facultatif)</label>
            <input type="text" name="recepteurAdresse" value={formData.recepteurAdresse} onChange={handleChange} className="form-control" />
          </div>

          <div className="col-md-12">
            <label>Images du colis</label>
            <input type="file" className="form-control" accept="image/*" multiple onChange={handleImageChange} />
          </div>
          {imagePreviews.length > 0 && (
            <div className="col-12 d-flex flex-wrap gap-2">
              {imagePreviews.map((src, i) => (
                <img key={i} src={src} alt="preview" width={100} className="img-thumbnail" />
              ))}
            </div>
          )}

          <div className="col-12">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Enregistrement..." : "📥 Enregistrer le colis"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
